import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useManagerPolicyContext } from 'contexts/ManagerPolicyContext';
import BaseInfo from 'components/Common/Policy/Views/BaseInfo';
import PolicyPlan from './PolicyPlan';
import NoPlans from './NoPlans';

export default function Policy() {
  const { dispatch, actions, state } = useManagerPolicyContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    actions.loadPolicy(dispatch, state.enterpriseId, () => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Row>
        <Col className="py-3">
          <LoadingPlaceholder text="Loading policy..." />
        </Col>
      </Row>
    );
  }

  if (state.policy.attributes.plans.length === 0) {
    return <NoPlans />;
  }

  const plans = state.policy.attributes.plans.filter((plan) => plan.attributes.active);

  return (
    <>
      <BaseInfo policy={state.policy} />

      <Row className="py-4 text-center">
        <Col lg={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
          <Row className="py-2 align-items-center border-bottom text-muted fw-light">
            <Col className="text-end">Plan</Col>
            <Col>Sessions</Col>
            <Col>Covered Members</Col>
            <Col>Available</Col>
          </Row>

          {plans.map((plan) => <PolicyPlan key={`policy-plan-${plan.id}`} plan={plan} />)}
        </Col>
      </Row>
    </>
  );
}
